// import { ChevronRight, ArrowLeft } from "lucide-react";
// import { useNavigate, useLocation } from "react-router-dom";
// import {
//   User,
//   Package,
//   MapPin,
//   Heart,
//   Ticket,
//   Settings,
// } from "lucide-react";

// const menuItems = [
//   { label: "Edit Profile", path: "/my-account", icon: User },
//   { label: "Orders", path: "/my-account/my-orders", icon: Package },
//   { label: "Saved Addresses", path: "/my-account/address", icon: MapPin },
//   { label: "Wishlist", path: "/my-account/wishlist", icon: Heart },
//   { label: "Coupon", path: "/my-account/coupon", icon: Ticket },
//   { label: "Settings", path: "/my-account/settings", icon: Settings },
// ];

// const MobileAccountMenu = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isMenu = location.pathname === "/my-account/menu";

//   const currentTitle =
//     menuItems.find((m) => m.path === location.pathname)?.label ||
//     "Account Settings";

//   return (
//     <div className="lg:hidden fixed inset-0 z-40 bg-[#F3F4F8]">
//       {/* HEADER */}
//       <div className="mt-32 md:mt-16 sticky top-0 h-14 bg-white flex items-center px-4 border-b z-50">
//         {!isMenu && (
//           <button onClick={() => navigate("/my-account")} className="mr-3">
//             <ArrowLeft size={22} />
//           </button>
//         )}
//         <h2 className="text-base font-semibold">
//           {isMenu ? "Account Settings" : currentTitle}
//         </h2>
//       </div>

//       {/* BODY */}
//       <div className="h-[calc(100vh-56px)] overflow-y-auto p-4">
//         {isMenu ? (
//           <div className="bg-white rounded-xl divide-y">
//             {menuItems.map((item) => {
//               const Icon = item.icon;
//               return (
//                 <button
//                   key={item.path}
//                   onClick={() => navigate(item.path)}
//                   className="w-full flex items-center justify-between px-4 py-4 text-sm"
//                 >
//                   <div className="flex items-center gap-3">
//                     <Icon size={18} className="text-blue-500" />
//                     <span>{item.label}</span>
//                   </div>
//                   <ChevronRight size={18} className="text-gray-400" />
//                 </button>
//               );
//             })}
//           </div>
//         ) : (
//           children
//         )}
//       </div>
//     </div>
//   );
// };

// export default MobileAccountMenu;


// import { ChevronRight, ArrowLeft } from "lucide-react";
// import { useNavigate, useLocation } from "react-router-dom";
// import {
//   User,
//   Package,
//   MapPin,
//   Heart,
//   Ticket,
//   Settings,
// } from "lucide-react";

// const menuItems = [
//   { label: "Edit Profile", path: "/my-account", icon: User },
//   { label: "Orders", path: "/my-account/my-orders", icon: Package },
//   { label: "Saved Addresses", path: "/my-account/address", icon: MapPin },
//   { label: "Wishlist", path: "/my-account/wishlist", icon: Heart },
//   { label: "Coupon", path: "/my-account/coupon", icon: Ticket },
//   { label: "Settings", path: "/my-account/settings", icon: Settings },
// ];

// const MobileAccountMenu = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isMenuScreen = location.pathname === "/my-account/menu";

//   const currentTitle =
//     menuItems.find((m) => m.path === location.pathname)?.label ||
//     "Account Settings";

//   return (
//     <div className="lg:hidden fixed inset-0 z-40 bg-[#F3F4F8]">
//       {/* HEADER */}
//       <div className="mt-32 sticky top-0 h-14 bg-white flex items-center px-4 border-b z-50">
//         {!isMenuScreen && (
//           <button
//             onClick={() => navigate("/my-account/menu")}
//             className="mr-3"
//           >
//             <ArrowLeft size={22} />
//           </button>
//         )}
//         <h2 className="text-base font-semibold">
//           {isMenuScreen ? "Account Settings" : currentTitle}
//         </h2>
//       </div>

//       {/* BODY */}
//       <div className="overflow-y-auto p-4">
//         {isMenuScreen ? (
//           <div className="bg-white rounded-xl divide-y">
//             {menuItems.map((item) => {
//               const Icon = item.icon;
//               return (
//                 <button
//                   key={item.path}
//                   onClick={() => navigate(item.path)}
//                   className="w-full flex items-center justify-between px-4 py-4 text-sm"
//                 >
//                   <div className="flex items-center gap-3">
//                     <Icon size={18} className="text-blue-500" />
//                     <span>{item.label}</span>
//                   </div>
//                   <ChevronRight size={18} className="text-gray-400" />
//                 </button>
//               );
//             })}
//           </div>
//         ) : (
//           children
//         )}
//       </div>
//     </div>
//   );
// };

// export default MobileAccountMenu;


// import { ChevronRight, ArrowLeft } from "lucide-react";
// import { useNavigate, useLocation } from "react-router-dom";
// import {
//   User,
//   Package,
//   MapPin,
//   Heart,
//   // Ticket,
//   Settings,
// } from "lucide-react";

// const menuItems = [
//   { label: "Edit Profile", path: "/my-account", icon: User },
//   { label: "Orders", path: "/my-account/my-orders", icon: Package },
//   { label: "Saved Addresses", path: "/my-account/address", icon: MapPin },
//   { label: "Wishlist", path: "/my-account/wishlist", icon: Heart },
//   // { label: "Coupon", path: "/my-account/coupon", icon: Ticket },
//   { label: "Settings", path: "/my-account/settings", icon: Settings },
// ];

// const MobileAccountMenu = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isMenuScreen = location.pathname === "/my-account/menu";

//   const currentTitle =
//     menuItems.find((m) => m.path === location.pathname)?.label ||
//     "Account Settings";

//   return (
//     <div className="lg:hidden fixed inset-0 z-40  bg-[#F3F4F8] flex flex-col">
//       {/* HEADER */}
//       <div className="mt-32 md:mt-16 h-14 bg-white flex items-center px-4 border-b flex-shrink-0">
//         {!isMenuScreen && (
//           <button
//             onClick={() => navigate("/my-account/menu")}
//             className="mr-3"
//           >
//             <ArrowLeft size={22} />
//           </button>
//         )}
//         <h2 className="text-base font-semibold">
//           {isMenuScreen ? "Account Settings" : currentTitle}
//         </h2>
//       </div>

//       {/* BODY (SCROLLABLE) */}
//       <div className="flex-1 overflow-y-auto p-4">
//         {isMenuScreen ? (
//           <div className="bg-white rounded-xl divide-y">
//             {menuItems.map((item) => {
//               const Icon = item.icon;
//               return (
//                 <button
//                   key={item.path}
//                   onClick={() => navigate(item.path)}
//                   className="w-full flex items-center justify-between px-4 py-4 text-sm"
//                 >
//                   <div className="flex items-center gap-3">
//                     <Icon size={18} className="text-blue-500" />
//                     <span>{item.label}</span>
//                   </div>
//                   <ChevronRight size={18} className="text-gray-400" />
//                 </button>
//               );
//             })}
//           </div>
//         ) : (
//           children
//         )}
//       </div>
//     </div>
//   );
// };

// export default MobileAccountMenu;


import { ChevronRight, ArrowLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  User,
  Package,
  MapPin,
  Heart,
  // Settings,
} from "lucide-react";

const menuItems = [
  { label: "Edit Profile", path: "/my-account", icon: User },
  { label: "Orders", path: "/my-account/my-orders", icon: Package },
  { label: "Saved Addresses", path: "/my-account/address", icon: MapPin },
  { label: "Wishlist", path: "/my-account/wishlist", icon: Heart },
  // { label: "Settings", path: "/my-account/settings", icon: Settings },
];

const MobileAccountMenu = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isMenuScreen = location.pathname === "/my-account/menu";

  const currentTitle =
    menuItems.find((m) => m.path === location.pathname)?.label ||
    "Account Settings";

  return (
    // CHANGE 1: Removed 'fixed inset-0 z-40'. Added 'min-h-screen' to ensure it takes up space.
    <div className="lg:hidden flex flex-col min-h-[50vh]">
      
      {/* HEADER */}
      {/* CHANGE 2: Removed 'mt-32 md:mt-16'. Added standard padding 'py-4' */}
      <div className="bg-white flex items-center px-4 py-4 border-b flex-shrink-0">
        {!isMenuScreen && (
          <button
            onClick={() => navigate("/my-account/menu")}
            className="mr-3"
          >
            <ArrowLeft size={22} />
          </button>
        )}
        <h2 className="text-base font-semibold">
          {isMenuScreen ? "Account Settings" : currentTitle}
        </h2>
      </div>

      {/* BODY */}
      {/* CHANGE 3: Removed 'overflow-y-auto' (let the main window scroll) and 'flex-1' */}
      <div className="p-4">
        {isMenuScreen ? (
          <div className="bg-white rounded-xl divide-y">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className="w-full flex items-center justify-between px-4 py-4 text-sm"
                >
                  <div className="flex items-center gap-3">
                    <Icon size={18} className="text-blue-500" />
                    <span>{item.label}</span>
                  </div>
                  <ChevronRight size={18} className="text-gray-400" />
                </button>
              );
            })}
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default MobileAccountMenu;